module.exports = __webpack_public_path__ + "520ea6ecd268c930ec719577745c8e02.svg";